/**
 * ConfirmationModal Component
 *
 * Reusable modal for confirming destructive actions.
 */

import React from "react";
import { modalStyles, gradients, colors } from "../styles";
import { OutlineButton, DangerButton } from "./Button";

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Action",
  message,
  warning,
  confirmText = "Confirm",
  cancelText = "Cancel",
  loading = false,
  variant = "danger",
}) => {
  if (!isOpen) return null;

  const headerBackgroundMap = {
    danger: gradients.danger,
    primary: gradients.primary,
  };

  return (
    <div style={modalStyles.overlay} onClick={onClose}>
      <div style={modalStyles.content} onClick={(e) => e.stopPropagation()}>
        {/* Header */}
        <div
          style={{
            ...modalStyles.header,
            background:
              headerBackgroundMap[variant] || headerBackgroundMap.danger,
          }}
        >
          <h3
            style={{
              margin: 0,
              color: colors.white,
              fontSize: "18px",
              fontWeight: 600,
            }}
          >
            {title}
          </h3>
          <button
            onClick={onClose}
            style={{
              background: "transparent",
              border: "none",
              color: colors.white,
              fontSize: "24px",
              cursor: "pointer",
              lineHeight: 1,
            }}
          >
            ×
          </button>
        </div>

        {/* Body */}
        <div style={modalStyles.body}>
          {message && (
            <p
              style={{
                margin: "0 0 16px",
                fontSize: "15px",
                color: colors.gray700,
              }}
            >
              {message}
            </p>
          )}
          {warning && (
            <div
              style={{
                padding: "14px 16px",
                background: colors.warningBg,
                border: `1px solid ${colors.warning}`,
                borderRadius: "4px",
                fontSize: "13px",
                color: colors.warningText,
              }}
            >
              <strong>Warning:</strong> {warning}
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={modalStyles.footer}>
          <OutlineButton onClick={onClose} disabled={loading}>
            {cancelText}
          </OutlineButton>
          <DangerButton onClick={onConfirm} disabled={loading}>
            {loading ? "Processing..." : confirmText}
          </DangerButton>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
